// @flow

import vb from './definition';

import type { IObservableDocumentType } from 'observable-document-type';

const isDocumentAnother = (documentType: IObservableDocumentType) => {
	return !(
		documentType.isDocumentRfPassport()
		|| documentType.isDocumentSeamanPassport()
		|| documentType.isDocumentRfBirthCertificate()
		|| documentType.isDocumentMilitaryPassport()
		|| documentType.isDocumentRefugeeID()
		|| documentType.isDocumentDiplomaticPassport()
		|| documentType.isDocumentTemporaryID()
		|| documentType.isDocumentForeignPassport()
		|| documentType.isDocumentResidencePermit()
		|| documentType.isDocumentTravelPassport()
	);
};

const identityDocumentValidateByType = (documentType: IObservableDocumentType) => {
	return vb.all([
		vb.if(
			() => isDocumentAnother(documentType),
			vb.all([vb.anotherPassport()]),
		),
		vb.if(
			() => documentType.isDocumentRfPassport(),
			vb.all([
				vb.passportRussian(),
				vb.notConsecutive6DigitsPassportNumber(),
			]),
		),
		vb.if(
			() => documentType.isDocumentSeamanPassport(),
			vb.all([vb.seamanPassport()]),
		),
		vb.if(
			() => documentType.isDocumentMilitaryPassport(),
			vb.all([vb.militaryPassport()]),
		),
		vb.if(
			() => documentType.isDocumentRfBirthCertificate(),
			vb.all([vb.birthCertificate()]),
		),
		vb.if(
			() => documentType.isDocumentDiplomaticPassport(),
			vb.all([
				vb.diplomaticPassport(),
				vb.notConsecutive7DigitsPassportNumber(),
			]),
		),
		vb.if(
			() => documentType.isDocumentRefugeeID(),
			vb.all([
				vb.refugeeID(),
				vb.notConsecutive7DigitsPassportNumber(),
			]),
		),
		vb.if(
			() => documentType.isDocumentTemporaryID(),
			vb.all([vb.temporaryID()]),
		),
		vb.if(
			() => documentType.isDocumentForeignPassport(),
			vb.all([vb.foreignPassport()]),
		),
		vb.if(
			() => documentType.isDocumentResidencePermit(),
			vb.all([
				vb.residencePermit(),
				vb.notConsecutive7DigitsPassportNumber(),
			]),
		),
		vb.if(
			() => documentType.isDocumentTravelPassport(),
			vb.all([vb.travelPassport()]),
		),
	]);
};

vb.physicalPersonIdentityDocumentValue = (documentType: IObservableDocumentType) => {
	return vb.all([
		identityDocumentValidateByType(documentType),
	]);
};

vb.physicalPersonLkIdentityDocumentValue = (documentType: IObservableDocumentType) => {
	return vb.all([
		vb.notOnlyZeroSeriesOrNumber(),
		identityDocumentValidateByType(documentType),
	]);
};